import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Custom hook to handle scrolling to sections
 * Handles both same-page scrolling and navigation + scrolling
 */
export const useScrollToSection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // Remove the leading # if present
    const id = sectionId.startsWith('#') ? sectionId.substring(1) : sectionId;
    
    const isHomePage = location.pathname === '/';
    
    if (!isHomePage) {
      // Navigate to home page first, then scroll after navigation
      navigate('/');
      // Use setTimeout to wait for the navigation to complete
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return scrollToSection;
};
